import { render, staticRenderFns } from "./SopQmsRequirementProposal.vue?vue&type=template&id=6327ffbe&scoped=true&"
import script from "./SopQmsRequirementProposal.vue?vue&type=script&lang=ts&"
export * from "./SopQmsRequirementProposal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6327ffbe",
  null
  
)

export default component.exports